<div class="right-margin">
  <button class="close-icon"  (click)="cancel()"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body">
  <h2>View Sales Agreement</h2>
  @if (contract) {
    <div class="long-text-cut text-nowarp">
      <b>HASH:</b> {{contract.termsHash}}
    </div>
  }
  @if (contract) {
    <div [innerHTML]="contract.terms" style="overflow: auto; max-height: 500px;"></div>
  }
</div>